/* tslint:disable */
/* eslint-disable */
/**
 * Farseer API
 * Farseer API
 *
 * The version of the OpenAPI document: 3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var RollupType;
(function (RollupType) {
    RollupType["None"] = "NONE";
    RollupType["Sum"] = "SUM";
    RollupType["Average"] = "AVERAGE";
    RollupType["ClosingState"] = "CLOSING STATE";
    RollupType["BeginningState"] = "BEGINNING STATE";
    RollupType["Formula"] = "FORMULA";
})(RollupType || (RollupType = {}));
export function RollupTypeFromJSON(json) {
    return RollupTypeFromJSONTyped(json, false);
}
export function RollupTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function RollupTypeToJSON(value) {
    return value;
}
